window.audioRecording = (function() {
    const startAudioRecording = async (dotnetRef, timeSlice, preferredDeviceId) => {
        const mediaTrackConstraint = preferredDeviceId ? { deviceId: { exact: preferredDeviceId } } : true;
        let stream;
        try {
            stream = await navigator.mediaDevices.getUserMedia({ audio: mediaTrackConstraint });
        } catch {
            return { success: () => false };
        }

        let streamDeviceId;
        if (mediaTrackConstraint !== true) {
            streamDeviceId = preferredDeviceId;
        }
        else {
            const devices = await navigator.mediaDevices.enumerateDevices();
            const streamDeviceGroupId = stream.getTracks()[0].getSettings().groupId;
            const streamDevices = devices.filter(i => i.kind === 'audioinput' && i.deviceId !== 'default' && i.groupId === streamDeviceGroupId);
            streamDeviceId = streamDevices.length === 1 ? streamDevices[0].deviceId : null;
        }

        let stopRequested = false;
        const recorder = new MediaRecorder(stream);
        recorder.ondataavailable = async blob => {
            const buffer = await blob.data.arrayBuffer();
            await dotnetRef.invokeMethodAsync('Write', new Uint8Array(buffer));
        };

        recorder.onstop = async e => {
            stream.getTracks().forEach(track => track.stop());
            if (stopRequested)
                await dotnetRef.invokeMethodAsync('Complete');
        }

        recorder.start(timeSlice);

        return {
            success: () => true,
            deviceId: () => streamDeviceId,
            stop: () => {
                stopRequested = true;
                try { recorder.stop(); } catch { }
            },
            cancel: () => {
                try { recorder.stop(); } catch { }
            },
        };
    }

    return {
        startAudioRecording: startAudioRecording,
    }
})();
